import sortable from 'html5sortable/dist/html5sortable.es'

const removeNewClass = function (item) {
  item.removeClass('new')
}

const update = (element, dataAttr, elementDataAttr) => {
  const tourId = element.data(dataAttr)
  const vehicle = element.data('vehicle')
  const vehiclePos = element.data('vehicle-position')
  let position = 1
  element.children('.delivery')
    .each(function (index, element) {
      const deliveryId = $(element).data(elementDataAttr)

      $(`#delivery_${deliveryId}_tour`).val(tourId)
      $(`#delivery_${deliveryId}_position`).val(position)
      $(`#delivery_${deliveryId}_vehicle`).val(vehicle)
      $(`#delivery_${deliveryId}_vehicle_position`).val(vehiclePos)

      position++
    })
}

const init = (element, acceptFrom, dataAttr, elementDataAttr) => {
  const [sortableElement] = sortable(element, {
    forcePlaceholderSize: true,
    acceptFrom,
    helper: 'clone',
    items: '.delivery'
  })
  sortableElement.addEventListener('sortupdate', event => {
    removeNewClass($(event.detail.item))
    update($(event.detail.destination.container), dataAttr, elementDataAttr)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const selectors = [
    {
      selector: '.vehicle-content',
      dataAttr: 'tour-id',
      elementDataAttr: 'delivery-id'
    },
    {
      selector: '.default-vehicle-content',
      dataAttr: 'vehicle',
      elementDataAttr: 'client-id'
    }
  ]

  selectors.forEach(sel => {
    const elements = document.querySelectorAll(sel.selector)
    if (elements.length > 0) {
      Array.from(elements).forEach(element => {
        init(element, sel.selector, sel.dataAttr, sel.elementDataAttr)
      })
    }
  })
})
